import { Button } from "@/src/components/buttons";
import { Card, CheckboxCard } from "@/src/components/cards";
import { closeDrawer, openDrawer } from "@/src/components/dialogs";
import { FetchableList } from "@/src/components/fetchableLists";
import { ReorderableItems } from "@/src/components/reorderable";
import { EvolutionItem, FolderItem, Hospitalisation, Patient } from "@/src/data/allTypes";
import { allItemTypes } from "@/src/data/data";
import apiFetch from "@/src/utils/apiFetch";
import { formatDate, getUserShortName, uid } from "@/src/utils/utils";
import { useState } from "react";
import { MdOutlineDragIndicator } from "react-icons/md";
import { openEvolutionVisualisationDrawer } from "../hospitalisation/openEvolutionVisualisation";
import moment from "moment";

export function ReorderableHospitalisationEvolutions({
    patient,
    parent,
    currentValue,
    onChange,
  }: {
    patient: Patient;
    parent: FolderItem;
    currentValue: EvolutionItem[];
    onChange: (newValue: EvolutionItem[]) => void;
  }) {
    let [items, setItems] = useState(currentValue);
  
    return (
      <div className="grid c1 gap10">
        <div className="grid c1 gap10">
          <ReorderableItems
            items={items || []}
            listId="evoltions"
            listType={"evoltions"}
            onReorder={(newItems) => {
              onChange(newItems);
              setItems(newItems);
            }}
          >
            {items?.map((item, index) => {
              if (!item) return null;
              const itemType = allItemTypes[item.type];
              return (
                <Card
                  key={uid()}
                  color="blue"
                  leading={
                    <div className="grab disabled">
                      <MdOutlineDragIndicator size={15} />
                    </div>
                  }
                  title={itemType?.name}
                  subTitle={getUserShortName(item?.creator)}
                  onClick={async () => {
                    if (!item) return;
                    await openEvolutionVisualisationDrawer({
                      items,
                      index,
                      patient,
                      // onEdit: async (newItem) => {
                      //   items = updateOrPush(items, newItem);
                      //   setItems([...items]);
                      // },
                    });
                  }}
                  onDelete={() => {
                    if (!item) return;
                    let newItems = [
                      ...items.filter((f) => f?.id != item?.id && f != null),
                    ];
                    setItems(newItems);
                    onChange(newItems);
                  }}
                >
                  {formatDate(item?._date, "LL HH:mm")}
                </Card>
              );
            })}
          </ReorderableItems>
        </div>
        <Button
          type={"tertiary"}
          onClick={async () => {
            let selectedItems: EvolutionItem[] = items || [];
            await openDrawer({
              id: "evolutionsDrawer",
              title: "Evènements",
              content: (
                <EvolutionsSelectionList
                  patient={parent.patient!}
                  current={selectedItems}
                  parent={parent as Hospitalisation}
                  onChange={(newItems) => {
                    selectedItems = newItems;
                  }}
                />
              ),
              onConfirm: () => {
                onChange(selectedItems);
                setItems(selectedItems);
                closeDrawer("evolutionsDrawer");
              },
            });
          }}
        >
          Choisir un évènement
        </Button>
      </div>
    );
  }
  
  function EvolutionsSelectionList({
    current,
    patient,
    parent,
    onChange,
  }: {
    current?: EvolutionItem[];
    patient: Patient;
    parent: FolderItem;
    onChange?: (selectedItems: EvolutionItem[]) => void | null | undefined;
  }) {
    const [reload, setReload] = useState(0);
    const [selectedItems, setSelectedItems] = useState(current || []);
    let [searchKey, setSearchKey] = useState("");
  
    return (
      <FetchableList
        queryKey={["EvolutionsSelectionList", searchKey, parent.id, reload]}
        queryFn={() =>
          apiFetch(
            "evolutionItems",
            "loadMany",
            {
              patientId: patient.id,
              parentId: parent?.id,
            },
            "Erreur lors du chargement de l'historique"
          )
        }
      >
        {(data) => (
          <div className="grid c1 gap10">
            {data?.map((item, index) => {
              let itemType = allItemTypes[item.type];
              return (
                <CheckboxCard
                  key={uid()}
                  status={
                    selectedItems.find((f) => f?.id == item?.id)
                      ? "active"
                      : "inactive"
                  }
                  color={item.status != "finished" ? "simple" : "blue"}
                  title={itemType?.name}
                  subTitle={getUserShortName(item?.creator)}
                  onEdit={async () => {
                    if (!data) return;
  
                    await openEvolutionVisualisationDrawer({
                      items: data,
                      index,
                      patient,
                      // onEdit: async (newItem) => {
                      //   data = updateOrPush(data, newItem);
                      //   setReload((prev) => prev + 1);
                      // },
                    });
                  }}
                  onClick={async (e) => {
                    e.stopPropagation();
  
                    let newItems = [...selectedItems];
                    if (newItems.find((f) => f?.id == item?.id)) {
                      newItems = selectedItems.filter((f) => f?.id != item?.id);
                    } else {
                      newItems.push(item);
                    }
                    setSelectedItems([...newItems]);
                    onChange?.(newItems);
                  }}
                >
                  <div className="c1 gap10">
                    <div className="gray">
                      {moment(item?._date).format("LL HH:mm")}
                    </div>
                  </div>
                </CheckboxCard>
              );
            })}
          </div>
        )}
      </FetchableList>
    );
  }
  